// store/modules/UserDetail.js
export const state = {
  userDetail: {
    type:''
  }
};

export const mutations = {
  SET_USER_DETAIL(state, detail) {
    state.userDetail = detail;
  }
};

export const actions = {
  setUserDetail({ commit }, detail) {
    commit('SET_USER_DETAIL', detail);
  }
};

export const getters = {
  getUserDetail: state => state.userDetail
};

